import { FC, useState } from 'react'
import { ExplainPayload } from 'helpers/explain'
import ExplainButton from './ExplainButton'
import useExplainGate, { getExplainCheckoutUrl } from 'hooks/useExplainGate'
import useAuthContext from 'contexts/Auth/useAuthContext'
import PaymentModal from './modals/PaymentModal'
import siteConfig from 'config'

const GatedExplainButton: FC<ExplainPayload> = (payload) => {
  const gate = useExplainGate()
  const { profile } = useAuthContext()
  const [showPayment, setShowPayment] = useState(false)

  if (!gate.allowed) {
    if (gate.reason === 'login') {
      return (
        <button
          onClick={gate.onUse}
          className="mt-2 text-xs font-medium text-slate-500 border border-slate-300 rounded-full px-3 py-1 hover:bg-slate-50 transition-colors"
        >
          {siteConfig.labels.explain.loginPrompt}
        </button>
      )
    }

    // limit reached
    const checkoutUrl = profile ? getExplainCheckoutUrl(profile.id) : ''
    return (
      <>
        <PaymentModal open={showPayment} close={() => setShowPayment(false)} link={checkoutUrl} />
        <button
          onClick={() => setShowPayment(true)}
          className="mt-2 text-xs font-medium text-amber-600 border border-amber-300 rounded-full px-3 py-1 hover:bg-amber-50 transition-colors"
        >
          {siteConfig.labels.explain.purchasePrompt} — {siteConfig.payments.explainPrice}
        </button>
      </>
    )
  }

  return <ExplainButton {...payload} onSuccess={gate.onUse} />
}

export default GatedExplainButton
